import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=b259ef84&scoped=true&"
import script from "./StatCard.vue?vue&type=script&lang=js&"
export * from "./StatCard.vue?vue&type=script&lang=js&"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=b259ef84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b259ef84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VIcon})
